export function settingsColumnLayout() {
  return {
    frame: "flex-1 md:ml-64 flex min-w-0 items-center justify-center px-6 py-12",
    column: "max-w-lg w-full min-w-0 break-words text-[#F3F4F6] font-body",
  };
}
